/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mobile-lock-title[_ngcontent-%COMP%]{color:#404040;text-align:center;margin-bottom:1rem}h1[_ngcontent-%COMP%]{font-size:1.125rem;font-weight:600}h2[_ngcontent-%COMP%]{font-size:1rem;font-weight:300}.app-links[_ngcontent-%COMP%]{text-align:center}.app-links[_ngcontent-%COMP%]   .app-badge[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:200px}"];
export { styles as styles };
//# sourceMappingURL=mobile-lock.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/mobile-lock/mobile-lock.component.scss.shim.ngstyle.js
// module id = 1393
// module chunks = 26 27 28